export default class SystemService {
    constructor({ core, viewer, viewerCoreAdapter }) {
        this.systems = {};
        this.isRegistered = (system) => this.core.services.entityManager
            .getSystemsRegistered()
            .some(({ id }) => id === system.id);
        this.registerSystem = (system) => this.core.services.entityManager.registerSystem(system);
        this.enableSystem = (systemId) => { var _a; return (_a = this.systems[systemId]) === null || _a === void 0 ? void 0 : _a.enable(); };
        this.disableSystem = (systemId) => { var _a; return (_a = this.systems[systemId]) === null || _a === void 0 ? void 0 : _a.disable(); };
        this.registerSystems = (systems) => {
            return Object.keys(systems).reduce((newSystemsObject, systemId) => {
                const { core, viewer, viewerCoreAdapter } = this;
                const sys = systems[systemId]({ core, viewer, viewerCoreAdapter });
                if (!this.isRegistered(sys))
                    this.registerSystem(sys);
                sys.disableOnLoad ? sys.disable() : sys.enable();
                this.systems = Object.assign(Object.assign({}, newSystemsObject), { [systemId]: sys });
                return this.systems;
            }, {});
        };
        this.loadDisabledOnLoadSystems = () => {
            Object.values(this.systems).forEach((system) => {
                system.disableOnLoad && system.enable();
            });
        };
        this.core = core;
        this.viewer = viewer;
        this.viewerCoreAdapter = viewerCoreAdapter;
    }
    get Systems() {
        return this.systems;
    }
}
